import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectMassiveSign = createSelector(
  [(store: RootState) => store.documentsSignerList.showMassiveSign],
  (type) => type
);
